import { Modal, Button } from "antd";

import InfoSection from "@/pages/Sprints/InfoSection";

const SprintInfoModal = ({ data, visible, readOnly, onOk, onCancel }) => {
  return (
    <Modal
      maskClosable={false}
      title="Информация"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      okText="Редактировать"
      cancelText="Закрыть"
      width={600}
      footer={
        readOnly
          ? [
              <Button key="cancel" onClick={onCancel}>
                Закрыть
              </Button>,
            ]
          : undefined // стандартный footer с двумя кнопками
      }
    >
      <InfoSection data={data} />
    </Modal>
  );
};

export default SprintInfoModal;
